export const basicDetails = {
  "Project Title": "Component",
  Model: "Model",
  "Job No": "Job No",
  "Serial No": "Serial No",
  "Dimensional Stage": "Stage 1",
  "Assets Type": "Tray",
  "KD Number": "KD2956",
  "WO Number": "WOAEI0003301",
  "QC Coordinator Remark":
    "This is remarks from QC Coordinator, testing a long remark to check the overflow of the remark field in the report",
  "QC Manager Remark":
    "This is remarks from QC Manager, testing a long remark to check the overflow of the remark field in the report",
};

export const basicReportColumn = [
  { id: "inspector_name", label: "Inspector Name" },
  { id: "from", label: "From" },
  { id: "date", label: "Date" },
  {
    id: "issued_revised_by",
    label: "Issued/Revised by",
    subLabel: "AEI QC Dept",
  },
  { id: "reviewed_by", label: "Reviewed by", subLabel: "Name & Sign off" },
  { id: "approved_by", label: "Approved by", subLabel: "Name & Sign off" },
];

export const basicReportData = [
  {
    inspector_name: "Sushant Kumar",
    from: "Austin Engg.",
    date: "2025-10-14",
    issued_revised_by: "Austin QA/QC",
    reviewed_by: "Amandeep Singh",
    approved_by: "Surbhi Joshi",
  },
];

export const ndtMapData = {
  ndt_map_id: 58,
  rfi_id: 191,
  remarks: "remark test",
  created_by: 4,
  approved_by: null,
  created_at: "2025-10-01T08:02:45.000Z",
  updated_at: "2025-10-01T08:02:45.000Z",
  ndt_documents: [
    {
      document_id: 107,
      ndt_map_id: 58,
      document:
        "https://austin-quality.dev.api.demos.classicinformatics.net/public/file-1759305762644.pdf",
      created_by: 4,
      created_at: "2025-10-01T08:02:45.000Z",
      updated_at: "2025-10-01T08:02:45.000Z",
    },
    {
      document_id: 108,
      ndt_map_id: 58,
      document:
        "https://austin-quality.dev.api.demos.classicinformatics.net/public/file-1759305765109.pdf",
      created_by: 4,
      created_at: "2025-10-01T08:02:45.000Z",
      updated_at: "2025-10-01T08:02:45.000Z",
    },
  ],
};

export const componentData = [
  {
    component_id: 235,
    rfi_id: 191,
    component_name: "Engine Block 1",
    component_template_id: null,
    component_images: [
      {
        image_id: 399,
        component_id: 235,
        image_url:
          "https://austin-quality.dev.api.demos.classicinformatics.net/api/files/public/file-1755603410519.png",
      },
      {
        image_id: 400,
        component_id: 235,
        image_url:
          "https://austin-quality.dev.api.demos.classicinformatics.net/api/files/public/file-1755603410519.png",
      },
      {
        image_id: 401,
        component_id: 235,
        image_url:
          "https://austin-quality.dev.api.demos.classicinformatics.net/api/files/public/file-1755603410519.png",
      },
      {
        image_id: 402,
        component_id: 235,
        image_url:
          "https://austin-quality.dev.api.demos.classicinformatics.net/api/files/public/file-1755603410519.png",
      },
    ],
    items: [
      {
        item_id: 328,
        component_id: 235,
        item_name: "Cylinder Head",
        sub_parts: [
          {
            subpart_id: 532,
            item_id: 328,
            description: "Main cylinder head",
            specification: "Aluminum alloy",
            tolerance: "23",
            actual_inspection: 23,
            finish_process: true,
            remark: "ASD",
          },
          {
            subpart_id: 533,
            item_id: 328,
            description: "Desc",
            specification: "Spec",
            tolerance: "65",
            actual_inspection: 43,
            finish_process: true,
            remark: "DSADD",
          },
        ],
      },
      {
        item_id: 329,
        component_id: 235,
        item_name: "Cylinder Head 2",
        sub_parts: [
          {
            subpart_id: 534,
            item_id: 329,
            description: "Main cylinder head",
            specification: "Aluminum alloy",
            tolerance: "23",
            actual_inspection: 23,
            finish_process: true,
            remark: "ASD",
          },
          {
            subpart_id: 535,
            item_id: 329,
            description: "Desc",
            specification: "Spec",
            tolerance: "65",
            actual_inspection: 43,
            finish_process: true,
            remark: "DSADD",
          },
        ],
      },
      {
        item_id: 329,
        component_id: 235,
        item_name: "Cylinder Head 2",
        sub_parts: [
          {
            subpart_id: 534,
            item_id: 329,
            description: "Main cylinder head",
            specification: "Aluminum alloy",
            tolerance: "23",
            actual_inspection: 23,
            finish_process: true,
            remark: "ASD",
          },
          {
            subpart_id: 535,
            item_id: 329,
            description: "Desc",
            specification: "Spec",
            tolerance: "65",
            actual_inspection: 43,
            finish_process: true,
            remark: "DSADD",
          },
        ],
      },
      {
        item_id: 329,
        component_id: 235,
        item_name: "Cylinder Head 2",
        sub_parts: [
          {
            subpart_id: 534,
            item_id: 329,
            description: "Main cylinder head",
            specification: "Aluminum alloy",
            tolerance: "23",
            actual_inspection: 23,
            finish_process: true,
            remark: "ASD",
          },
          {
            subpart_id: 535,
            item_id: 329,
            description: "Desc",
            specification: "Spec",
            tolerance: "65",
            actual_inspection: 43,
            finish_process: true,
            remark: "DSADD",
          },
        ],
      },
      {
        item_id: 329,
        component_id: 235,
        item_name: "Cylinder Head 2",
        sub_parts: [
          {
            subpart_id: 534,
            item_id: 329,
            description: "Main cylinder head",
            specification: "Aluminum alloy",
            tolerance: "23",
            actual_inspection: 23,
            finish_process: true,
            remark: "ASD",
          },
          {
            subpart_id: 535,
            item_id: 329,
            description: "Desc",
            specification: "Spec",
            tolerance: "65",
            actual_inspection: 43,
            finish_process: true,
            remark: "DSADD",
          },
        ],
      },
    ],
  },
  {
    component_id: 235,
    rfi_id: 191,
    component_name: "Engine Block 1",
    component_template_id: null,
    component_images: [
      {
        image_id: 399,
        component_id: 235,
        image_url:
          "https://austin-quality.dev.api.demos.classicinformatics.net/api/files/public/file-1755603410519.png",
      },
      {
        image_id: 400,
        component_id: 235,
        image_url:
          "https://austin-quality.dev.api.demos.classicinformatics.net/api/files/public/file-1755603410519.png",
      },
      {
        image_id: 401,
        component_id: 235,
        image_url:
          "https://austin-quality.dev.api.demos.classicinformatics.net/api/files/public/file-1755603410519.png",
      },
      {
        image_id: 402,
        component_id: 235,
        image_url:
          "https://austin-quality.dev.api.demos.classicinformatics.net/api/files/public/file-1755603410519.png",
      },
    ],
    items: [
      {
        item_id: 328,
        component_id: 235,
        item_name: "Cylinder Head",
        sub_parts: [
          {
            subpart_id: 532,
            item_id: 328,
            description: "Main cylinder head",
            specification: "Aluminum alloy",
            tolerance: "23",
            actual_inspection: 23,
            finish_process: true,
            remark: "ASD",
          },
          {
            subpart_id: 533,
            item_id: 328,
            description: "Desc",
            specification: "Spec",
            tolerance: "65",
            actual_inspection: 43,
            finish_process: true,
            remark: "DSADD",
          },
        ],
      },
      {
        item_id: 329,
        component_id: 235,
        item_name: "Cylinder Head 2",
        sub_parts: [
          {
            subpart_id: 534,
            item_id: 329,
            description: "Main cylinder head",
            specification: "Aluminum alloy",
            tolerance: "23",
            actual_inspection: 23,
            finish_process: true,
            remark: "ASD",
          },
          {
            subpart_id: 535,
            item_id: 329,
            description: "Desc",
            specification: "Spec",
            tolerance: "65",
            actual_inspection: 43,
            finish_process: true,
            remark: "DSADD",
          },
        ],
      },
      {
        item_id: 329,
        component_id: 235,
        item_name: "Cylinder Head 2",
        sub_parts: [
          {
            subpart_id: 534,
            item_id: 329,
            description: "Main cylinder head",
            specification: "Aluminum alloy",
            tolerance: "23",
            actual_inspection: 23,
            finish_process: true,
            remark: "ASD",
          },
          {
            subpart_id: 535,
            item_id: 329,
            description: "Desc",
            specification: "Spec",
            tolerance: "65",
            actual_inspection: 43,
            finish_process: true,
            remark: "DSADD",
          },
        ],
      },
      {
        item_id: 329,
        component_id: 235,
        item_name: "Cylinder Head 2",
        sub_parts: [
          {
            subpart_id: 534,
            item_id: 329,
            description: "Main cylinder head",
            specification: "Aluminum alloy",
            tolerance: "23",
            actual_inspection: 23,
            finish_process: true,
            remark: "ASD",
          },
          {
            subpart_id: 535,
            item_id: 329,
            description: "Desc",
            specification: "Spec",
            tolerance: "65",
            actual_inspection: 43,
            finish_process: true,
            remark: "DSADD",
          },
        ],
      },
      {
        item_id: 329,
        component_id: 235,
        item_name: "Cylinder Head 2",
        sub_parts: [
          {
            subpart_id: 534,
            item_id: 329,
            description: "Main cylinder head",
            specification: "Aluminum alloy",
            tolerance: "23",
            actual_inspection: 23,
            finish_process: true,
            remark: "ASD",
          },
          {
            subpart_id: 535,
            item_id: 329,
            description: "Desc",
            specification: "Spec",
            tolerance: "65",
            actual_inspection: 43,
            finish_process: true,
            remark: "DSADD",
          },
        ],
      },
    ],
  },
];

export const componentColumn = [
  { id: "item_name", label: "Item Name" },
  { id: "description", label: "Description" },
  { id: "specification", label: "Specification" },
  { id: "tolerance", label: "Tolerance" },
  { id: "actual_inspection", label: "Actual Inspection" },
  { id: "finish_process", label: "Finish Process" },
  { id: "remark", label: "Remark" },
];
